import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Civility_Enum } from '@gql'
import React, { forwardRef } from 'react'
import { ControllerRenderProps } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export const CivilitySelect = forwardRef<
  HTMLInputElement,
  { field: ControllerRenderProps<any>; className?: string }
>(({ field, className }, ref) => {
  const { t } = useTranslation()
  return (
    <FormItem className={className}>
      <FormLabel>{t('CivilitySelect.label')}</FormLabel>
      <Select onValueChange={field.onChange} value={field.value}>
        <FormControl>
          <SelectTrigger className="tw-w-full">
            <SelectValue
              ref={ref}
              placeholder={t('CivilitySelect.placeholder')}
            />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          {Object.values(Civility_Enum).map((status) => (
            <SelectItem value={status} key={status}>
              {t(`CivilitySelect.${status}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <FormMessage />
    </FormItem>
  )
})

CivilitySelect.displayName = 'CivilitySelect'
